/**
 * EIP-2612 Permit ABI extension
 *
 * These functions are not part of standard ERC20 but are implemented by
 * tokens that support gasless approvals (like USDC on Base).
 */
export const permitAbi = [
	{
		inputs: [{ name: "owner", type: "address" }],
		name: "nonces",
		outputs: [{ name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [
			{ name: "owner", type: "address" },
			{ name: "spender", type: "address" },
			{ name: "value", type: "uint256" },
			{ name: "deadline", type: "uint256" },
			{ name: "v", type: "uint8" },
			{ name: "r", type: "bytes32" },
			{ name: "s", type: "bytes32" },
		],
		name: "permit",
		outputs: [],
		stateMutability: "nonpayable",
		type: "function",
	},
] as const
